/**
 * 渠道仓配置枚举
 */

//库存精度取值（1.进一法、2.退一法）
export enum StockAccuracy {
  /**
   * 进一法
   */
  UP = 1,
  /**
   * 退一法
   */
  DOWN = 2,
}
export enum StockAccuracyName {
  /**
   * 进一法
   */
  UP = '进一法',
  /**
   * 退一法
   */
  DOWN = '退一法',
}

//是否主仓(0-否，1-是)
export enum IsMainWarehouse {
  /**
   * 否
   */
  NO = 0,
  /**
   * 是
   */
  YES = 1,
}
export enum IsMainWarehouseName {
  NO = '否',
  YES = '是',
}

//是否勾选警戒值（1.是、2.否）
export enum IsCheckAlertValue {
  /**
   * 是
   */
  YES = 1,
  /**
   * 否
   */
  NO = 2,
}
export enum IsCheckAlertValueName {
  YES = '是',
  NO = '否',
}

//状态（1.正常，2.停用）
export enum Status {
  /**
   * 正常
   */
  NORMAL = 1,
  /**
   * 停用
   */
  DISABLED = 2,
}
export enum StatusName {
  NORMAL = '正常',
  DISABLED = '停用',
}

// 使用优先级（0、优先使用共享库存，1、优先使用独享库存）
export enum UsePriority {
  /**
   * 优先使用共享库存
   */
  SHARED = 0,
  /**
   * 优先使用独享库存
   */
  PRIVATE = 1,
}
export enum UsePriorityName {
  SHARED = '优先使用共享库存',
  PRIVATE = '优先使用独享库存',
}